export function canManageGuardList(user, type) {
  const permissions = user?.junior_list_permissions;
  if (!permissions) return false;
  const key = String(type || '').toUpperCase().replace(/[\s-]+/g, '_');
  return !Object.hasOwn(permissions, key) || permissions[key].can_manage === true;
}

export function manualJuniorListPath(user, type, mois) {
  const key = String(type || '').toUpperCase().replace(/[\s-]+/g, '_');
  const permission = user?.junior_list_permissions?.[key];
  if (!permission?.can_withdraw) return null;
  const query = new URLSearchParams({ secteur: permission.secteur_id, type: key, mois, view: 'liste' });
  return `/multisecteur/responsable/gestion-garde.html?${query}`;
}

export function juniorListReadSlug(user, type) {
  const key = String(type || '').toUpperCase().replace(/[\s-]+/g, '_');
  return Object.hasOwn(user?.junior_list_permissions || {}, key)
    ? key.toLowerCase().replace(/_/g, '-') : null;
}
